import type { CampaignRecord } from '@workspace/types';
import { CAMPAIGN_TEMPLATE_VARIABLE_SOURCE_LABELS } from '@workspace/utils';

function formatMapping(
  mapping: Record<string, string> | undefined,
): Array<{ slot: string; label: string }> {
  if (!mapping) {
    return [];
  }
  return Object.entries(mapping)
    .filter(([slot]) => /^\d{1,2}$/.test(slot))
    .sort(([a], [b]) => Number(a) - Number(b))
    .map(([slot, source]) => ({
      slot,
      label:
        CAMPAIGN_TEMPLATE_VARIABLE_SOURCE_LABELS[
          source as keyof typeof CAMPAIGN_TEMPLATE_VARIABLE_SOURCE_LABELS
        ] ?? source,
    }));
}

export function ContactAgentCampaignTemplatesSection({
  campaign,
}: {
  campaign: CampaignRecord;
}) {
  const retry = campaign.steps?.find(step => step.stepOrder === 1);
  const templates = [
    {
      label: 'Plantilla inicial',
      name: campaign.initialTemplateId,
      mapping: campaign.initialTemplateId
        ? campaign.templateVariableMap?.[campaign.initialTemplateId]
        : undefined,
    },
    {
      label: 'Reintento',
      name: retry?.templateId ?? null,
      mapping:
        retry?.templateId && campaign.templateVariableMap
          ? campaign.templateVariableMap[retry.templateId]
          : undefined,
      waitHours: retry?.waitHours,
    },
  ].filter(item => item.name);

  if (templates.length === 0) {
    return null;
  }

  return (
    <section className='space-y-3'>
      <h2 className='text-lg font-semibold'>Plantillas</h2>
      <div className='grid gap-4 lg:grid-cols-2'>
        {templates.map(template => (
          <div key={template.name ?? template.label} className='rounded-xl border p-4'>
            <p className='text-sm font-medium'>{template.label}</p>
            <p className='mt-1 font-mono text-sm'>{template.name}</p>
            {'waitHours' in template && template.waitHours ? (
              <p className='mt-2 text-sm text-muted-foreground'>
                Espera: {template.waitHours} h
              </p>
            ) : null}
            <div className='mt-3 space-y-1 text-sm'>
              {formatMapping(template.mapping).length > 0 ? (
                formatMapping(template.mapping).map(item => (
                  <p key={item.slot}>
                    <span className='font-mono'>{`{{${item.slot}}}`}</span>
                    <span className='text-muted-foreground'> → {item.label}</span>
                  </p>
                ))
              ) : (
                <p className='text-muted-foreground'>Mapeo por defecto del sistema.</p>
              )}
            </div>
          </div>
        ))}
      </div>
      <p className='text-xs text-muted-foreground'>
        Tipo de campaña: {campaign.purpose === 'AVISO' ? 'Aviso / contacto' : 'Cobranzas'}
      </p>
    </section>
  );
}
